import * as React from "react";
import { Modal, Button } from "antd";

export interface State {}

export interface Props {
  translate: any;
  visible?: boolean;
  removeAttribute?: any;
  onCancel: any;
}

export default class InvalidateAttributeModal extends React.Component<
  Props,
  State
> {
  render() {
    const { translate, visible, removeAttribute, onCancel } = this.props;

    return (
      <div>
        <Modal
          title={translate("remove_attribute_modal.title")}
          visible={visible}
          maskClosable={false}
          onCancel={onCancel}
          footer={[
            <Button key="back" onClick={onCancel}>
              {translate("modal_functions.remove_modal.cancel")}
            </Button>,
            <Button key="submit" type="danger" onClick={removeAttribute}>
              {translate("modal_functions.remove_modal.remove")}
            </Button>
          ]}
        >
          {translate("remove_attribute_modal.text")}
        </Modal>
      </div>
    );
  }
}
